import React, { Component } from 'react';
import {Route, Link} from 'react-router-dom';

import './NanumBarunGothic.scss';

class NanumBarunGothic extends Component {
  render() {
    const {input, onChange} = this.props;

    return (
      <li>
        <Link to="/nanum_barungothic/detail">
          <div className="dashed-wrap nanum_barungothic">
            <h4 className="content-title">
              <span className="font-company">Naver, Sandoll</span>
              <span className="font-title">나눔 바른 고딕 / Nanum Barun Gothic</span>
            </h4>
            <p className="font-text">{input}</p>
          </div>
        </Link>
      </li>
    );
  }
}

export default NanumBarunGothic;